// tslint:disable
// This file is generated by buildArt script.
// Please don't edit it manually.
export var IdAssetBundleGrounds;
(function (IdAssetBundleGrounds) {
    IdAssetBundleGrounds["background_tile"] = "background_tile";
    IdAssetBundleGrounds["blocked_expansion_1_path"] = "blocked_expansion_1_path";
    IdAssetBundleGrounds["blocked_expansion_2_path"] = "blocked_expansion_2_path";
    IdAssetBundleGrounds["blocked_expansion_3"] = "blocked_expansion_3";
    IdAssetBundleGrounds["blocked_expansion_4"] = "blocked_expansion_4";
    IdAssetBundleGrounds["blocked_expansion_5"] = "blocked_expansion_5";
    IdAssetBundleGrounds["ground_dirt"] = "ground_dirt";
})(IdAssetBundleGrounds || (IdAssetBundleGrounds = {}));



//////////////////
// WEBPACK FOOTER
// ./src/assetBundles/IdAssetBundleGrounds.ts
// module id = 865
// module chunks = 3